import type { CurrencyCode } from '@klear/constants/currency'
import { Money } from '@klear/money'

export type PayableTotal = {
  total: Money
  currencies: CurrencyCode[]
}

export function payableTotalFromComponents(components: Money[], fallbackCurrency: CurrencyCode): PayableTotal {
  const contributing = components.filter((component) => !component.isZero())
  const currencies = [...new Set(contributing.map((component) => component.currency))].sort()

  const total = Money.sum(components)
  if (contributing.length === 0) {
    total.currency = fallbackCurrency
  }

  return { total, currencies }
}
